import { Component, OnInit, ViewChild, EventEmitter, Output, } from '@angular/core';
import * as _ from 'lodash';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';

@Component({
  selector: 'app-confirmar-nota-venta-modal-resultado',
  templateUrl: './modal-resultado.component.html',
  styleUrls: ['../confirmar-nota-venta.component.scss'],
})
export class ConfirmarNotaVentaModalResultadoComponent implements OnInit {
  @ViewChild('verResultado', { static: true }) verResultadoModal: ModalDirective;
  @ViewChild('erroresModal', { static: true }) verErroresModal: ModalDirective;

  // OUTPUT
  @Output() ActualizarFiltro: EventEmitter<any> = new EventEmitter<any>()

  // Utils
  private log: any

  detalleDocumento: any[]
  detalleDocumentoAll: any[]
  paginationContextDocumento: PaginationContext = new PaginationContext()

  detalleErrores: any[]
  detalleErroresAll: any[]
  paginationContextErrores: PaginationContext = new PaginationContext()

  sumMontoNeto: number = null
  sumMontoBruto: number = null
  // Callbacks
  private closeCallback: Function;

  constructor(
    private clog: ConsoleService
  ) {
    this.log = this.clog.log('VER-RESULTADO')
  }

  ngOnInit() {
    this.paginationContextDocumento.RecordsByPage = 10
    this.paginationContextErrores.RecordsByPage = 10
  }

  loadAndShow(data: any[], closeCallback: Function = null) {
    this.cleanUp()
    this.log('loadAndShow', data)

    this.closeCallback = closeCallback

    this.paginationContextDocumento.RecordsCount = data.length //totalRegistros
    this.paginationContextDocumento.PagesCount = Math.ceil(this.paginationContextDocumento.RecordsCount / this.paginationContextDocumento.RecordsByPage) //totalPaginas
    this.paginationContextDocumento.CurrentPage = 1 // paginaActual
    this.detalleDocumentoAll = data
    this.showPageDocumentos(1)

    this.verResultadoModal.show()
    this.ActualizarFiltro.emit();
  }

  cleanUp() {
    this.detalleDocumentoAll = null
    this.detalleDocumento = null
  }

  showPageDocumentos(pageNumber: number) {
    this.paginationContextDocumento.CurrentPage = pageNumber
    const start = (this.paginationContextDocumento.CurrentPage - 1) * this.paginationContextDocumento.RecordsByPage
    this.detalleDocumento = _.slice(this.detalleDocumentoAll, start, start + this.paginationContextDocumento.RecordsByPage)

    const sumallNeto = this.detalleDocumentoAll.map(item => item.cabecera.monto_total_neto ).reduce((prev, curr) => prev + curr, 0);
    const sumallBruto = this.detalleDocumentoAll.map(item => item.cabecera.monto_total ).reduce((prev, curr) => prev + curr, 0);

    this.sumMontoNeto = sumallNeto
    this.sumMontoBruto = sumallBruto
  }

  onPageChangeDocumentos(context: PaginationContext) {
    this.showPageDocumentos(context.RequestedPage)
  }

  showErrores(logErrores) {
    this.paginationContextErrores.RecordsCount = logErrores.length //totalRegistros
    this.paginationContextErrores.PagesCount = Math.ceil(this.paginationContextErrores.RecordsCount / this.paginationContextErrores.RecordsByPage) //totalPaginas
    this.paginationContextErrores.CurrentPage = 1 // paginaActual
    this.detalleErroresAll = logErrores
    this.showPageErrores(1)
    this.verErroresModal.show()
  }

  showPageErrores(pageNumber: number) {
    this.paginationContextErrores.CurrentPage = pageNumber
    const start = (this.paginationContextErrores.CurrentPage - 1) * this.paginationContextErrores.RecordsByPage
    this.detalleErrores = _.slice(this.detalleErroresAll, start, start + this.paginationContextErrores.RecordsByPage)
  }

  onPageChangeErrores(context: PaginationContext) {
    this.showPageErrores(context.RequestedPage)
  }

  closeModal() {
    if (this.closeCallback)
      this.closeCallback()
    this.verResultadoModal.hide()
  }

}
